import { render, staticRenderFns } from "./CommodityContain.vue?vue&type=template&id=707edd21&scoped=true&"
import script from "./CommodityContain.vue?vue&type=script&lang=js&"
export * from "./CommodityContain.vue?vue&type=script&lang=js&"
import style0 from "./CommodityContain.vue?vue&type=style&index=0&id=707edd21&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "707edd21",
  null
  
)

export default component.exports